// 人才管理模块

//获取个人简历信息
function userInfo(psnid, CVID = "") {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), psnid, CVID, pagename: "bGetUserInfo" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取个人简历信息出错");
            resolve(false);
          }
        } else {
          console.log("获取个人简历信息出错");
          resolve(false);
        }
      }
    });
  });
}

//获取人才
function getAllTalents(search) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), pagename: "bGetTotalList", msg: JSON.stringify(search) },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取人才出错");
            resolve(false);
          }
        } else {
          console.log("获取人才出错");
          resolve(false);
        }
      }
    });
  });
}

//获取职位信息
function getJobInformation(jobid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", pagename: "bGetJobInfo", pageid: "1", jobId: jobid },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取职位信息出错");
            resolve(false);
          }
        } else {
          console.log("获取职位信息出错");
          resolve(false);
        }
      }
    });
  });
}

//获取申请管理/申请历史的人才
function deliveryTalents(data) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), action: "edit", pagename: "bOrderlistPage", msg: JSON.stringify(data) },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取申请管理/申请历史的人才出错");
            resolve(false);
          }
        } else {
          console.log("获取申请管理/申请历史的人才出错");
          resolve(false);
        }
      }
    });
  });
}

//获取申请和职位数量
function jobDeliveryNum(idList) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { type: "a", action: "edit", userid: Cookies.get("userid-b"), arrentid: idList, pagename: "bGetEntJobCount" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取申请和职位数量出错");
            resolve(false);
          }
        } else {
          console.log("获取申请和职位数量出错");
          resolve(false);
        }
      }
    });
  });
}

//通过人才申请
function approveTalentDelivery(jobid, CVID, msg) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "save", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), jobid, CVID, msg, pagename: "passToSendEnt" },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("通过人才申请出错");
            resolve(false);
          }
        } else {
          console.log("通过人才申请出错");
          resolve(false);
        }
      }
    });
  });
}

//拒绝人才申请
function refuseTalentDelivery(CVID, msg) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "save", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), CVID, pagename: "bRefuseResume", msg },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(true) : resolve(false);
          } catch (e) {
            console.log("拒绝人才申请出错");
            resolve(false);
          }
        } else {
          console.log("拒绝人才申请出错");
          resolve(false);
        }
      }
    });
  });
}

//获取用户手机号
function getUserCell(cvid) {
  return new Promise(resolve => {
    $.ajax({
      type: "post",
      url: APIB,
      data: { action: "edit", pagename: 'bGetUserTelByCvid', userid: Cookies.get("userid-b"), cvid },
      dataType: "json",
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            if (jsonRes.status == "ok" && jsonRes.msg) {
              resolve(jsonRes.msg.psnProBaseSource.StrUserMobile);
            } else {
              resolve(false);
            }
          } catch (e) {
            resolve(false);
          }
        } else {
          resolve(false);
        }
      }
    });
  });
}

//获取手机号(可获取多人的)
function getCellNumber(psnids) {
  return new Promise(resolve => {
    $.ajax({
      url: APIB,
      async: true,
      type: "post",
      dataType: "json",
      data: { action: "edit", type: "p", userid: Cookies.get("userid-b"), entid: Cookies.get("userid-b"), pagename: "bGetUserTel", psnids },
      success: res => {
        if (res) {
          try {
            const jsonRes = JSON.parse(res);
            jsonRes.status == "ok" ? resolve(jsonRes.msg) : resolve(false);
          } catch (e) {
            console.log("获取手机号出错");
            resolve(false);
          }
        } else {
          console.log("获取手机号出错");
          resolve(false);
        }
      }
    });
  });
}

export default {
  userInfo,
  getAllTalents,
  getJobInformation,
  deliveryTalents,
  jobDeliveryNum,
  approveTalentDelivery,
  refuseTalentDelivery,
  getUserCell,
  getCellNumber
};
